// extracted by mini-css-extract-plugin
export default {"container":"jX6pL","profilePage":"QhAUw","textColumn":"Vwjru","spacer":"iM2V1","logout":"RCNo5","caption":"uAUff","balance":"XnxRW","avatar":"f6byS"};